<template>
	<div class="auth-page">
		<!-- LEFT — command-center hero -->
		<aside class="auth-hero">
			<div class="auth-hero__brand">
				<span class="auth-hero__mark">MC<span class="auth-hero__mark-badge">2</span></span>
				<div>
					<div class="auth-hero__brand-name">Town Web</div>
					<div class="auth-hero__brand-sub">Mission Control v2</div>
				</div>
			</div>

			<div class="auth-hero__map">
				<conquest-map />
			</div>

			<div class="auth-hero__copy">
				<h2 class="auth-hero__headline">
					Powering local government <em>across America.</em>
				</h2>

				<div class="auth-hero__stats">
					<div>
						<div class="auth-hero__stat-num">900+</div>
						<div class="auth-hero__stat-lbl">Municipalities</div>
					</div>
					<div>
						<div class="auth-hero__stat-num">43</div>
						<div class="auth-hero__stat-lbl">States</div>
					</div>
					<div>
						<div class="auth-hero__stat-num">3.5M</div>
						<div class="auth-hero__stat-lbl">Residents served</div>
					</div>
				</div>

				<div class="auth-family">
					<div class="auth-family__label">One platform family</div>
					<div class="auth-family__logos">
						<a class="auth-chip" href="https://townweb.com" target="_blank" rel="noopener noreferrer">
							<img class="auth-chip__icon auth-chip__icon--townweb" src="/images/brands/townweb-icon.png" alt="" />
							<span class="auth-chip__name">Town Web</span>
						</a>
						<a class="auth-chip" href="https://heygov.com" target="_blank" rel="noopener noreferrer">
							<img class="auth-chip__icon" src="/images/brands/heygov-bubble.svg" alt="" />
							<span class="auth-chip__name">HeyGov</span>
						</a>
						<a class="auth-chip" href="https://clerkminutes.com" target="_blank" rel="noopener noreferrer">
							<img class="auth-chip__icon" src="/images/brands/clerkminutes-icon.svg" alt="" />
							<span class="auth-chip__name">ClerkMinutes</span>
						</a>
					</div>
				</div>
			</div>
		</aside>

		<!-- RIGHT — form -->
		<main class="auth-panel">
			<div class="auth-form-wrap">
				<div class="auth-brandbar">
					<span class="auth-hero__mark">MC<span class="auth-hero__mark-badge">2</span></span>
					<div>
						<div class="auth-hero__brand-name" style="color:#191a1a">Town Web</div>
						<div class="auth-hero__brand-sub" style="color:#6b7171">Mission Control v2</div>
					</div>
				</div>

				<slot />

				<div class="auth-foot">
					© {{ year }} Town Web · Mission Control 2 · Secure municipal operations
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import ConquestMap from './ConquestMap.vue'

export default {
	name: 'AuthShell',
	components: { ConquestMap },
	computed: {
		year() {
			return new Date().getFullYear()
		},
	},
}
</script>
